module.exports = __webpack_public_path__ + "static/media/email_failed.3910eeaf.png";